
import React from 'react';

const ShippingPage: React.FC = () => {
  return (
    <div className="container mx-auto px-4 md:px-6 py-20">
      <div className="max-w-3xl mx-auto space-y-12">
        <h1 className="text-4xl font-serif font-bold text-stone-900">Teslimat & Kargo</h1>
        <div className="prose prose-stone text-stone-600 space-y-8 font-medium">
          <section className="space-y-4">
            <h3 className="text-xl font-bold text-stone-900">Kargo Süreci</h3>
            <p>Siparişleriniz, el yapımı olduğu için 1-3 iş günü içerisinde hazırlanarak kargoya teslim edilmektedir.</p>
          </section>
          <section className="space-y-4">
            <h3 className="text-xl font-bold text-stone-900">Kargo Ücretleri</h3>
            <p>Lumina Home üzerinden yapacağınız tüm alışverişlerde standart kargo ücretsizdir.</p>
          </section>
          <section className="space-y-4">
            <h3 className="text-xl font-bold text-stone-900">Paketleme Güvencesi</h3>
            <p>Ürünlerimiz hassas yapıda olduğu için darbelere dayanıklı, özel korumalı ambalajlarla gönderilmektedir.</p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default ShippingPage;
